import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentModule} from 'app/component/component.module';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {HtethdComponent} from 'app/tool-layer/tools/htethd/htethd.component';

@NgModule({
    imports: [ComponentModule, CommonModule],
    declarations: [HtethdComponent],
    entryComponents: [HtethdComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(HtethdComponent),
            multi: true,
        },
    ],
})
export class HtethdModule {}
